import {Component} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {UtilsService} from '../../../services/utils.service';
import {TagService} from '../../../services/tag.service';
import {LocationsService} from '../../../services/locations.service';
import { debounceTime } from 'rxjs/operators';
import {Subject} from 'rxjs/Subject';
import {DistrictsService} from '../../../services/districts.service';

declare var $: any;
declare var UIkit: any;

@Component({
  selector: 'app-location-view',
  templateUrl: './location-view.component.html',
  styleUrls: ['./location-view.component.scss']
})
export class LocationViewComponent {

  parentsList = [];

  modelChanged: Subject<string> = new Subject<string>();

  locationRegions = [];



  location = {};

  constructor(private graphqlService: LocationsService,
              private utilsService: UtilsService,
              private tagService: TagService,
              private router: Router,
              private districtsService: DistrictsService,
              private route: ActivatedRoute) {

    this.modelChanged.pipe(
      debounceTime(1500)
    ).subscribe(model => this.updateLocation());

    route.params.subscribe(params => {
      if (params['id']) {
        const id = params['id'];

        this.graphqlService.getLocationRegions().subscribe(result => {
          if (result && result.data) {
            this.locationRegions = JSON.parse(JSON.stringify(result.data['locationRegions']));
            
          }
        });

        this.graphqlService.read(id).subscribe(result => {
          if (result && result.data) {
            this.location = JSON.parse(JSON.stringify(result.data['location']));
            if (this.location['parent']) {
              this.location['parentId'] = this.location['parent'].id;
            }
            this.utilsService.openSnackBar('Data Loaded !!', '');
          }
        });

        this.districtsService.getAllDistricts().subscribe(result => {
          if (result && result.data) {
            this.parentsList = result.data['districts'];
          }
        });
      }
    });
  }

  dataChanged() {
    this.modelChanged.next();
  }

  updateLocation() {
    const requiredSuccess = this.utilsService.validateRequiredFields(this.location['name']);
    if (requiredSuccess) {
      this.graphqlService.update(this.location).subscribe((response) => {
        if (response.errors && response.errors.length > 0) {
          const errors = response.errors.map(err => err.message);
          this.utilsService.openSnackBar(errors, '');
        } else {
          this.utilsService.openSnackBar('Location Updated !!', '');
        }
      }, (error) => {
        this.utilsService.openSnackBar('Unable to update Location.', '');
        console.log('there was an error sending the query', error);
      });
    }
  }

  deleteLocation() {
    UIkit.modal($('#confirm-delete')).hide();
    $('#confirm-delete').remove();
    this.graphqlService.delete(this.location).subscribe(({data}) => {
      this.utilsService.openSnackBar('Location Deleted !!', '');
      this.router.navigate(['/locations']);
    }, (error) => {
      this.utilsService.openSnackBar('Unable to delete location.', '');
      console.log('there was an error sending the query', error);
    });
  }

}




// WEBPACK FOOTER //
// /Users/ugyen/Documents/Bhutan-office/my_bhutan/mybhutan-travel/src-admin/app/components/locations/location-view/location-view.component.ts